<template>
  <div>
    <v-data-table dense :headers="headers" :items="desserts" :search="search" sort-by="id" class="elevation-1">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-btn icon @click="close">
            <v-icon>close</v-icon>
          </v-btn>
          <!-- <v-toolbar-title>Пользователи организации</v-toolbar-title> -->
          <!-- <v-divider class="mx-4" inset vertical></v-divider> -->
          <!-- <v-spacer></v-spacer> -->
          <v-text-field v-model="search" append-icon="search" clearable label="Поиск ..." single-line
            hide-details></v-text-field>
          <v-spacer></v-spacer>
          <v-btn class="mb-2" @click="AddOrganisationUser"><v-icon left>add</v-icon>Добавить пользователя
            организации</v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.active="{ item }">
        <v-chip x-small :color="getColor(item.active)" :class="{ 'white--text': item.active }">{{ getBool(item.active)
        }}</v-chip>
      </template>
      <template v-slot:item.action="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> edit </v-icon>
        <v-icon normal class="removes mr-2" @click="removeUserDialog(item)">delete_forever</v-icon>
        <v-icon small @click="recoverByEmail(item.email)" title="Отправить восстановление пароля">mail</v-icon>
      </template>
      <template v-slot:item.role="{ item }">
        <span>{{ getRoleName(item.role) }}</span>
      </template>
    </v-data-table>
    <v-progress-linear :active="loading" :indeterminate="loading" absolute bottom
      color="deep-purple accent-4"></v-progress-linear>
    <DeleteUser v-model="removeDialog" @close="removeDialog = false" :userInfo="removeItem" @save="removeUser()" />
  </div>
</template>


<script>
import DeleteUser from "../../components/DeleteUser.vue";
export default {
  components: { DeleteUser },
  data: () => ({
    search: "",
    dialog: false,
    loading: false,
    headers: [
      {
        text: "Логин",
        align: "left",
        sortable: false,
        value: "email",
      },

      { text: "Фамилия", value: "famil" },
      { text: "Имя", value: "name" },
      { text: "№ телефона", value: "phone" },
      { text: "Дата активации", value: "email_verified_at" },
      { text: "Роль", value: "role" },
      { text: "Активен", value: "active" },
      { text: "Действия", value: "action", sortable: false },
    ],
    removeDialog: false,
    removeItem: null,
  }),

  computed: {
    desserts() {
      return this.$store.getters.GetOrganisationUsersUM;
    },
    formTitle() {
      return this.editedIndex === -1 ? "New Item" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    //this.initialize()
  },

  methods: {
    getBool(val) {
      if (val) return "Да";
      else return "Нет";
    },
    getColor(color) {
      if (color) return "red";
      return "transparent";
    },

    AddOrganisationUser() {
      if (this.$route.query && this.$route.query.redirect === 'adminpanelfinexpert') {
        return this.$router.push("/adduserum?redirect=adminpanelfinexpert");
      }
      this.$router.push({ name: "adduserum" });
    },
    removeUserDialog(item) {
      this.removeItem = item;
      this.removeDialog = true;
    },
    async removeUser() {
      this.loading = true;
      const user = this.removeItem;
      await this.$store.dispatch("REMOVE_USER", {
        _id: user.user_id,
      });
      const id = this.$store.getters.GetCurrentOrganisationIDUM;
      this.$store.dispatch("getUsersOfOrganisation", { id }).then((res) => {
        this.loading = false;
        this.removeDialog = false;
        this.$store.dispatch("GetUserManagementSettings");
      });
    },
    editItem(item) {
      // this.editedIndex = this.desserts.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.dialog = true
      this.loading = true;
      this.$store
        .dispatch("getOrganisationUserUM", item)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "edituserum" });
        })
        .catch((error) => {
          this.loading = false;
          alert(error);
        });
    },

    close() {
      this.$store.commit("SET_CURRENT_ORGANISATION_UM", {});
      this.$store.commit("SET_CURRENT_ORGANISATION_ID_UM", null);
      if (this.$route.query && this.$route.query.redirect === 'adminpanelfinexpert') {
        return this.$router.push({ name: "adminpanelfinexpert" });
      }
      this.$router.push({ name: "adminpanel" });
    },

    save() {
      if (this.editedIndex > -1) {
        Object.assign(this.desserts[this.editedIndex], this.editedItem);
      } else {
        this.desserts.push(this.editedItem);
      }
      this.close();
    },

    users(item) {
      this.loading = true;
      this.$store
        .dispatch("getUsersOfOrganisation", item)
        .then(() => {
          this.loading = false;
          this.$router.push({ name: "usersorganisationtable" });
        })
        .catch((error) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.setTitle(`Пользователи организации`);
  },
};
</script>
